

export default {
  name: 'MediSelectModal',
  props: {
    value: {
      type: [String, Boolean, Number, Array],
      default: '',
    },

    items: {
      type: Array,
      required: true,
    },

    itemValue: {
      type: String,
      required: true,
    },

    itemText: {
      type: String,
      required: true,
    },

    isOpen: {
      type: Boolean,
      default: false,
    },

    isSearch: {
      type: Boolean,
      default: false,
    },

    isPending: {
      type: Boolean,
      default: false,
    },

    labelInside: {
      type: String,
      default: '',
    },

  },

  data () {
    return {
      searchText: '',
    }
  },

  watch: {
    searchText (searchText) {
      this.$emit('search-text', searchText)
    },
  },

  methods: {
    searchFocus () {
      this.searchText = ''
      this.$nextTick(() => {
        if (this.isSearch) {
          this.$refs.modalSearch?.focus()
        }
      })
    },
  },
}
